export const xtrfInitialFilterState = {
    name: '',
    sourceLanguages: [],
    targetLanguages: [],
    priceMin: '',
    priceMax: '',
    status: '',
    startDateFromTo: { to: null, from: null },
    deadlineFromTo: { to: null, from: null },
}
